import React, { Component } from "react";
import { Button } from "antd";
import { IoVolumeHigh, IoVolumeMute } from "react-icons/io5";
import { isBrowser } from "react-device-detect";
import { setHtmlStorage } from "../../config/helper";

class AvatarAI extends Component {
  constructor(props) {
    super(props);
    this.getAvatar = JSON.parse(localStorage.getItem("dataAvatar"));
    this.muteState = localStorage.getItem("muteState");
  }

  muteAvatar = () => {
    if (this.muteState === "true") {
      setHtmlStorage("muteState", "false");
    } else {
      setHtmlStorage("muteState", "true");
    }
    window.location.reload();
  };

  render() {
    if (this.props.disabled) {
      return <div className="avatar-middle" />;
    }

    return (
      <div className="avatar-middle">
        <img src={this.getAvatar?.aIsrc} alt={this.getAvatar?.aIname} />
        <div className="buddy-name">
          <span>
            {this.getAvatar?.aIname ? this.getAvatar?.aIname : "Name"}
          </span>
          <Button
            icon={
              <svg
                width="24"
                height="23"
                viewBox="0 0 24 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.55 18.4L10.16 16.79L8.3775 14.95H13.15V12.65H8.3775L10.16 10.81L8.55 9.2L3.95 13.8L8.55 18.4ZM15.45 13.8L20.05 9.2L15.45 4.6L13.84 6.21L15.6225 8.05H10.85V10.35H15.6225L13.84 12.19L15.45 13.8ZM12 23C10.4092 23 8.91417 22.6981 7.515 22.0944C6.11583 21.4906 4.89875 20.6713 3.86375 19.6362C2.82875 18.6012 2.00937 17.3842 1.40563 15.985C0.801875 14.5858 0.5 13.0908 0.5 11.5C0.5 9.90917 0.801875 8.41417 1.40563 7.015C2.00937 5.61583 2.82875 4.39875 3.86375 3.36375C4.89875 2.32875 6.11583 1.50937 7.515 0.905625C8.91417 0.301875 10.4092 0 12 0C13.5908 0 15.0858 0.301875 16.485 0.905625C17.8842 1.50937 19.1012 2.32875 20.1362 3.36375C21.1713 4.39875 21.9906 5.61583 22.5944 7.015C23.1981 8.41417 23.5 9.90917 23.5 11.5C23.5 13.0908 23.1981 14.5858 22.5944 15.985C21.9906 17.3842 21.1713 18.6012 20.1362 19.6362C19.1012 20.6713 17.8842 21.4906 16.485 22.0944C15.0858 22.6981 13.5908 23 12 23Z"
                  fill="white"
                />
              </svg>
            }
            onClick={() => this.props.swapAvatar(!this.props.stateSwapAvatar)}
            style={{
              width: "24px",
              height: "24px",
              marginLeft: "10px",
              padding: 0,
              border: 0,
              background: "transparent",
            }}
          />
          {isBrowser && (
            <Button
              icon={
                this.muteState === "true" ? (
                  <IoVolumeMute size={22} />
                ) : (
                  <IoVolumeHigh size={22} />
                )
              }
              className="ant-btn-mute"
              onClick={() => this.muteAvatar()}
            />
          )}
        </div>
      </div>
    );
  }
}

export default AvatarAI;
